// extracted by mini-css-extract-plugin
module.exports = {"submenu":"menu_submenu__Z9YZ7"};